import language from './language'

const Configs = {
	language
}

Object.freeze(Configs)

export default Configs
